import { css } from 'lit';

/* stylelint-disable */
/* eslint-disable */
export const gravityTooltip = css`
  /* prettier-ignore */
  .grv-tooltip {
    background-color: #141414;
    border-radius: 2px;
    color: #ffffff;
    display: none;
    outline: 0;
    position: relative;
    text-align: left;
    transform-origin: top;
    white-space: nowrap;
    cursor: auto;
    z-index: 1;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    padding: 16px;
  }

  .grv-tooltip--large {
    width: 256px;
    white-space: normal;
  }

  .grv-tooltip--small {
    width: 128px;
    white-space: normal;
  }

  .grv-tooltip--light {
    color: #141414;
    background: #ffffff;
  }

  .grv-tooltip__trigger {
    cursor: pointer;
    position: relative;
  }

  span.grv-tooltip__trigger:not(.grv-tooltip__info-icon):not(.grv-tooltip__info-icon--light) {
    border-bottom: 1px dashed;
  }

  button.grv-tooltip__trigger:not(.grv-button--ghost),
  input.grv-tooltip__trigger:not(.grv-button--ghost) {
    border-bottom: 0;
  }

  .grv-tooltip__trigger--light {
    color: #ffffff;
  }

  .grv-tooltip__trigger.grv-tooltip__info-icon,
  .grv-tooltip__trigger.grv-tooltip__info-icon--light {
    border-bottom: 0;
  }

  .grv-tooltip__info-icon::after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23141414'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    left: 100%;
    height: 16px;
    width: 16px;
    content: '';
    border-bottom: 0 none;
    margin-left: 4px;
    margin-top: 4px;
  }

  .grv-tooltip__info-icon:hover::after,
  .grv-tooltip__info-icon:focus::after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%233D3D3D'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    left: 100%;
    height: 16px;
    width: 16px;
    content: '';
  }

  .grv-tooltip__info-icon--light::after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    left: 100%;
    height: 16px;
    width: 16px;
    content: '';
    border-bottom: 0 none;
    margin-left: 4px;
    margin-top: 4px;
  }

  .grv-tooltip__info-icon--light:hover::after,
  .grv-tooltip__info-icon--light:focus::after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23D4D4D4'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    left: 100%;
    height: 16px;
    width: 16px;
    content: '';
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--top-center,
  .grv-tooltip__trigger:hover + .grv-tooltip--top-center,
  .grv-tooltip__trigger:focus .grv-tooltip--top-center,
  .grv-tooltip__trigger:hover .grv-tooltip--top-center,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--top-center {
    bottom: 100%;
    display: block;
    left: 50%;
    right: initial;
    position: absolute;
    top: initial;
    margin-bottom: 16px;
    transform: translate(-50%, 8px);
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--top-left,
  .grv-tooltip__trigger:hover + .grv-tooltip--top-left,
  .grv-tooltip__trigger:focus .grv-tooltip--top-left,
  .grv-tooltip__trigger:hover .grv-tooltip--top-left,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--top-left {
    bottom: 100%;
    display: block;
    left: 0;
    position: absolute;
    right: initial;
    top: initial;
    margin-bottom: 8px;
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--top-right,
  .grv-tooltip__trigger:hover + .grv-tooltip--top-right,
  .grv-tooltip__trigger:focus .grv-tooltip--top-right,
  .grv-tooltip__trigger:hover .grv-tooltip--top-right,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--top-right {
    bottom: 100%;
    display: block;
    left: initial;
    position: absolute;
    right: 0;
    top: initial;
    margin-bottom: 8px;
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--bottom-center,
  .grv-tooltip__trigger:hover + .grv-tooltip--bottom-center,
  .grv-tooltip__trigger:focus .grv-tooltip--bottom-center,
  .grv-tooltip__trigger:hover .grv-tooltip--bottom-center,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--bottom-center {
    display: block;
    position: absolute;
    bottom: initial;
    left: 50%;
    right: initial;
    top: 100%;
    transform: translate(-50%, -8px);
    margin-top: 16px;
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--bottom-left,
  .grv-tooltip__trigger:hover + .grv-tooltip--bottom-left,
  .grv-tooltip__trigger:focus .grv-tooltip--bottom-left,
  .grv-tooltip__trigger:hover .grv-tooltip--bottom-left,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--bottom-left {
    display: block;
    position: absolute;
    bottom: initial;
    left: 0;
    right: initial;
    top: 100%;
    margin-top: 8px;
  }

  .grv-tooltip__trigger:focus + .grv-tooltip--bottom-right,
  .grv-tooltip__trigger:hover + .grv-tooltip--bottom-right,
  .grv-tooltip__trigger:focus .grv-tooltip--bottom-right,
  .grv-tooltip__trigger:hover .grv-tooltip--bottom-right,
  .grv-tooltip__trigger .grv-tooltip--active.grv-tooltip--bottom-right {
    display: block;
    position: absolute;
    bottom: initial;
    left: initial;
    right: 0;
    top: 100%;
    margin-top: 8px;
  }

  .grv-tooltip__info-icon:focus .grv-tooltip--top-right,
  .grv-tooltip__info-icon:hover .grv-tooltip--top-right,
  .grv-tooltip__info-icon--light:focus .grv-tooltip--top-right,
  .grv-tooltip__info-icon--light:hover .grv-tooltip--top-right {
    right: -16px;
  }
`;

export const gravityCard = css`
  /* prettier-ignore */
  .grv-card {
    background: #ffffff;
    border: 0;
    border-radius: 8px;
    box-sizing: border-box;
    color: #141414;
    display: flex;
    flex-basis: auto;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    min-width: 208px;
    position: relative;
    text-align: left;
    text-decoration: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }

  .grv-card:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .grv-card--color-bar {
    border-top: 8px solid #013d5b;
  }

  .grv-card__media {
    background-position: center center;
    background-size: cover;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    height: 168px;
    max-width: 100%;
  }

  .grv-card__media--top-left {
    background-position: left top;
  }

  .grv-card__media--top-center {
    background-position: top;
  }

  .grv-card__media--top-right {
    background-position: right top;
  }

  .grv-card__media--center-left {
    background-position: left;
  }

  .grv-card__media--center-center {
    background-position: center;
  }

  .grv-card__media--center-right {
    background-position: right;
  }

  .grv-card__media--bottom-left {
    background-position: left bottom;
  }

  .grv-card__media--bottom-center {
    background-position: bottom;
  }

  .grv-card__media--bottom-right {
    background-position: right bottom;
  }

  .grv-card__link {
    color: #0276b1;
    text-decoration: underline;
  }

  .grv-card__link:visited {
    color: #663399;
  }

  .grv-card__link:hover {
    color: #026597;
  }

  .grv-card__link:active {
    color: #014e74;
  }

  .grv-card__link--expand:not(.grv-button--text-directional-right)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
  }

  .grv-card__link--expand:not(.grv-button--text-directional-left)::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
  }

  .grv-card__content {
    margin: 0;
    margin-bottom: 24px;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .grv-card__content :last-child {
    margin-bottom: 0;
  }

  .grv-card__heading {
    margin: 0;
    margin-bottom: 24px;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 24px;
    line-height: 1.5;
    font-weight: 300;
    margin-bottom: 8px;
  }

  .grv-card__body {
    margin: 0;
    margin-bottom: 24px;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
  }

  .grv-card__footer {
    flex-grow: 0;
    padding-left: 24px;
    padding-right: 24px;
    margin-bottom: 24px;
    margin-top: 24px;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 12px;
    line-height: 1.5;
    font-weight: 400;
  }

  .grv-card__info-icon {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23141414'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border-bottom: 0 none;
    content: '';
    display: inline-block;
    height: 24px;
    width: 24px;
    vertical-align: middle;
    margin-right: 8px;
  }

  .grv-card__section--anchor {
    margin-top: auto;
  }

  .grv-card__link-scope {
    position: relative;
  }
`;

export const gravitySpacing = css`
  /* prettier-ignore */
  .grv-margin--none {
    margin: 0px;
  }

  .grv-margin__top--none {
    margin-top: 0px;
  }

  .grv-margin__right--none {
    margin-right: 0px;
  }

  .grv-margin__bottom--none {
    margin-bottom: 0px;
  }

  .grv-margin__left--none {
    margin-left: 0px;
  }

  .grv-margin--small-1 {
    margin: 4px;
  }

  .grv-margin__top--small-1 {
    margin-top: 4px;
  }

  .grv-margin__right--small-1 {
    margin-right: 4px;
  }

  .grv-margin__bottom--small-1 {
    margin-bottom: 4px;
  }

  .grv-margin__left--small-1 {
    margin-left: 4px;
  }

  .grv-margin--small-2,
  .grv-margin--tiny {
    margin: 8px;
  }

  .grv-margin__top--small-2,
  .grv-margin__top--tiny {
    margin-top: 8px;
  }

  .grv-margin__right--small-2,
  .grv-margin__right--tiny {
    margin-right: 8px;
  }

  .grv-margin__bottom--small-2,
  .grv-margin__bottom--tiny {
    margin-bottom: 8px;
  }

  .grv-margin__left--small-2,
  .grv-margin__left--tiny {
    margin-left: 8px;
  }

  .grv-margin--medium-1,
  .grv-margin--small {
    margin: 16px;
  }

  .grv-margin__top--medium-1,
  .grv-margin__top--small {
    margin-top: 16px;
  }

  .grv-margin__right--medium-1,
  .grv-margin__right--small {
    margin-right: 16px;
  }

  .grv-margin__bottom--medium-1,
  .grv-margin__bottom--small {
    margin-bottom: 16px;
  }

  .grv-margin__left--medium-1,
  .grv-margin__left--small {
    margin-left: 16px;
  }

  .grv-margin--medium-2,
  .grv-margin--normal {
    margin: 24px;
  }

  .grv-margin__top--medium-2,
  .grv-margin__top--normal {
    margin-top: 24px;
  }

  .grv-margin__right--medium-2,
  .grv-margin__right--normal {
    margin-right: 24px;
  }

  .grv-margin__bottom--medium-2,
  .grv-margin__bottom--normal {
    margin-bottom: 24px;
  }

  .grv-margin__left--medium-2,
  .grv-margin__left--normal {
    margin-left: 24px;
  }

  .grv-margin--large-1,
  .grv-margin--medium {
    margin: 32px;
  }

  .grv-margin__top--large-1,
  .grv-margin__top--medium {
    margin-top: 32px;
  }

  .grv-margin__right--large-1,
  .grv-margin__right--medium {
    margin-right: 32px;
  }

  .grv-margin__bottom--large-1,
  .grv-margin__bottom--medium {
    margin-bottom: 32px;
  }

  .grv-margin__left--large-1,
  .grv-margin__left--medium {
    margin-left: 32px;
  }

  .grv-margin--large-2 {
    margin: 40px;
  }

  .grv-margin__top--large-2 {
    margin-top: 40px;
  }

  .grv-margin__right--large-2 {
    margin-right: 40px;
  }

  .grv-margin__bottom--large-2 {
    margin-bottom: 40px;
  }

  .grv-margin__left--large-2 {
    margin-left: 40px;
  }

  .grv-margin--large-3,
  .grv-margin--large {
    margin: 48px;
  }

  .grv-margin__top--large-3,
  .grv-margin__top--large {
    margin-top: 48px;
  }

  .grv-margin__right--large-3,
  .grv-margin__right--large {
    margin-right: 48px;
  }

  .grv-margin__bottom--large-3,
  .grv-margin__bottom--large {
    margin-bottom: 48px;
  }

  .grv-margin__left--large-3,
  .grv-margin__left--large {
    margin-left: 48px;
  }

  .grv-margin--large-4 {
    margin: 56px;
  }

  .grv-margin__top--large-4 {
    margin-top: 56px;
  }

  .grv-margin__right--large-4 {
    margin-right: 56px;
  }

  .grv-margin__bottom--large-4 {
    margin-bottom: 56px;
  }

  .grv-margin__left--large-4 {
    margin-left: 56px;
  }

  .grv-margin--xlarge-1,
  .grv-margin--xlarge {
    margin: 64px;
  }

  .grv-margin__top--xlarge-1,
  .grv-margin__top--xlarge {
    margin-top: 64px;
  }

  .grv-margin__right--xlarge-1,
  .grv-margin__right--xlarge {
    margin-right: 64px;
  }

  .grv-margin__bottom--xlarge-1,
  .grv-margin__bottom--xlarge {
    margin-bottom: 64px;
  }

  .grv-margin__left--xlarge-1,
  .grv-margin__left--xlarge {
    margin-left: 64px;
  }

  .grv-margin--xlarge-2 {
    margin: 72px;
  }

  .grv-margin__top--xlarge-2 {
    margin-top: 72px;
  }

  .grv-margin__right--xlarge-2 {
    margin-right: 72px;
  }

  .grv-margin__bottom--xlarge-2 {
    margin-bottom: 72px;
  }

  .grv-margin__left--xlarge-2 {
    margin-left: 72px;
  }

  .grv-margin--xlarge-3 {
    margin: 80px;
  }

  .grv-margin__top--xlarge-3 {
    margin-top: 80px;
  }

  .grv-margin__right--xlarge-3 {
    margin-right: 80px;
  }

  .grv-margin__bottom--xlarge-3 {
    margin-bottom: 80px;
  }

  .grv-margin__left--xlarge-3 {
    margin-left: 80px;
  }

  .grv-margin--xlarge-4 {
    margin: 88px;
  }

  .grv-margin__top--xlarge-4 {
    margin-top: 88px;
  }

  .grv-margin__right--xlarge-4 {
    margin-right: 88px;
  }

  .grv-margin__bottom--xlarge-4 {
    margin-bottom: 88px;
  }

  .grv-margin__left--xlarge-4 {
    margin-left: 88px;
  }

  .grv-margin--xlarge-5,
  .grv-margin--xxlarge {
    margin: 96px;
  }

  .grv-margin__top--xlarge-5,
  .grv-margin__top--xxlarge {
    margin-top: 96px;
  }

  .grv-margin__right--xlarge-5,
  .grv-margin__right--xxlarge {
    margin-right: 96px;
  }

  .grv-margin__bottom--xlarge-5,
  .grv-margin__bottom--xxlarge {
    margin-bottom: 96px;
  }

  .grv-margin__left--xlarge-5,
  .grv-margin__left--xxlarge {
    margin-left: 96px;
  }

  .grv-padding--none {
    padding: 0px;
  }

  .grv-padding__top--none {
    padding-top: 0px;
  }

  .grv-padding__right--none {
    padding-right: 0px;
  }

  .grv-padding__bottom--none {
    padding-bottom: 0px;
  }

  .grv-padding__left--none {
    padding-left: 0px;
  }

  .grv-padding--small-1 {
    padding: 4px;
  }

  .grv-padding__top--small-1 {
    padding-top: 4px;
  }

  .grv-padding__right--small-1 {
    padding-right: 4px;
  }

  .grv-padding__bottom--small-1 {
    padding-bottom: 4px;
  }

  .grv-padding__left--small-1 {
    padding-left: 4px;
  }

  .grv-padding--small-2,
  .grv-padding--tiny {
    padding: 8px;
  }

  .grv-padding__top--small-2,
  .grv-padding__top--tiny {
    padding-top: 8px;
  }

  .grv-padding__right--small-2,
  .grv-padding__right--tiny {
    padding-right: 8px;
  }

  .grv-padding__bottom--small-2,
  .grv-padding__bottom--tiny {
    padding-bottom: 8px;
  }

  .grv-padding__left--small-2,
  .grv-padding__left--tiny {
    padding-left: 8px;
  }

  .grv-padding--medium-1,
  .grv-padding--small {
    padding: 16px;
  }

  .grv-padding__top--medium-1,
  .grv-padding__top--small {
    padding-top: 16px;
  }

  .grv-padding__right--medium-1,
  .grv-padding__right--small {
    padding-right: 16px;
  }

  .grv-padding__bottom--medium-1,
  .grv-padding__bottom--small {
    padding-bottom: 16px;
  }

  .grv-padding__left--medium-1,
  .grv-padding__left--small {
    padding-left: 16px;
  }

  .grv-padding--medium-2,
  .grv-padding--normal {
    padding: 24px;
  }

  .grv-padding__top--medium-2,
  .grv-padding__top--normal {
    padding-top: 24px;
  }

  .grv-padding__right--medium-2,
  .grv-padding__right--normal {
    padding-right: 24px;
  }

  .grv-padding__bottom--medium-2,
  .grv-padding__bottom--normal {
    padding-bottom: 24px;
  }

  .grv-padding__left--medium-2,
  .grv-padding__left--normal {
    padding-left: 24px;
  }

  .grv-padding--large-1,
  .grv-padding--medium {
    padding: 32px;
  }

  .grv-padding__top--large-1,
  .grv-padding__top--medium {
    padding-top: 32px;
  }

  .grv-padding__right--large-1,
  .grv-padding__right--medium {
    padding-right: 32px;
  }

  .grv-padding__bottom--large-1,
  .grv-padding__bottom--medium {
    padding-bottom: 32px;
  }

  .grv-padding__left--large-1,
  .grv-padding__left--medium {
    padding-left: 32px;
  }

  .grv-padding--large-2 {
    padding: 40px;
  }

  .grv-padding__top--large-2 {
    padding-top: 40px;
  }

  .grv-padding__right--large-2 {
    padding-right: 40px;
  }

  .grv-padding__bottom--large-2 {
    padding-bottom: 40px;
  }

  .grv-padding__left--large-2 {
    padding-left: 40px;
  }

  .grv-padding--large-3,
  .grv-padding--large {
    padding: 48px;
  }

  .grv-padding__top--large-3,
  .grv-padding__top--large {
    padding-top: 48px;
  }

  .grv-padding__right--large-3,
  .grv-padding__right--large {
    padding-right: 48px;
  }

  .grv-padding__bottom--large-3,
  .grv-padding__bottom--large {
    padding-bottom: 48px;
  }

  .grv-padding__left--large-3,
  .grv-padding__left--large {
    padding-left: 48px;
  }

  .grv-padding--large-4 {
    padding: 56px;
  }

  .grv-padding__top--large-4 {
    padding-top: 56px;
  }

  .grv-padding__right--large-4 {
    padding-right: 56px;
  }

  .grv-padding__bottom--large-4 {
    padding-bottom: 56px;
  }

  .grv-padding__left--large-4 {
    padding-left: 56px;
  }

  .grv-padding--xlarge-1,
  .grv-padding--xlarge {
    padding: 64px;
  }

  .grv-padding__top--xlarge-1,
  .grv-padding__top--xlarge {
    padding-top: 64px;
  }

  .grv-padding__right--xlarge-1,
  .grv-padding__right--xlarge {
    padding-right: 64px;
  }

  .grv-padding__bottom--xlarge-1,
  .grv-padding__bottom--xlarge {
    padding-bottom: 64px;
  }

  .grv-padding__left--xlarge-1,
  .grv-padding__left--xlarge {
    padding-left: 64px;
  }

  .grv-padding--xlarge-2 {
    padding: 72px;
  }

  .grv-padding__top--xlarge-2 {
    padding-top: 72px;
  }

  .grv-padding__right--xlarge-2 {
    padding-right: 72px;
  }

  .grv-padding__bottom--xlarge-2 {
    padding-bottom: 72px;
  }

  .grv-padding__left--xlarge-2 {
    padding-left: 72px;
  }

  .grv-padding--xlarge-3 {
    padding: 80px;
  }

  .grv-padding__top--xlarge-3 {
    padding-top: 80px;
  }

  .grv-padding__right--xlarge-3 {
    padding-right: 80px;
  }

  .grv-padding__bottom--xlarge-3 {
    padding-bottom: 80px;
  }

  .grv-padding__left--xlarge-3 {
    padding-left: 80px;
  }

  .grv-padding--xlarge-4 {
    padding: 88px;
  }

  .grv-padding__top--xlarge-4 {
    padding-top: 88px;
  }

  .grv-padding__right--xlarge-4 {
    padding-right: 88px;
  }

  .grv-padding__bottom--xlarge-4 {
    padding-bottom: 88px;
  }

  .grv-padding__left--xlarge-4 {
    padding-left: 88px;
  }

  .grv-padding--xlarge-5,
  .grv-padding--xxlarge {
    padding: 96px;
  }

  .grv-padding__top--xlarge-5,
  .grv-padding__top--xxlarge {
    padding-top: 96px;
  }

  .grv-padding__right--xlarge-5,
  .grv-padding__right--xxlarge {
    padding-right: 96px;
  }

  .grv-padding__bottom--xlarge-5,
  .grv-padding__bottom--xxlarge {
    padding-bottom: 96px;
  }

  .grv-padding__left--xlarge-5,
  .grv-padding__left--xxlarge {
    padding-left: 96px;
  }
`;

export const gravityButton = css`
  /* prettier-ignore */
  .grv-button {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: #0276b1;
    border: 0;
    color: #ffffff;
  }

  @media only screen and (min-width: 600px) {
    .grv-button {
      min-width: 88px;
    }
  }

  .grv-button:visited {
    color: #ffffff;
  }

  .grv-button:hover {
    background: #026597;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button:active {
    background: #014e74;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--action {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: #25810e;
    border: 0;
    color: #ffffff;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--action {
      min-width: 88px;
    }
  }

  .grv-button--action:visited {
    color: #ffffff;
  }

  .grv-button--action:hover {
    background: #1e6a0b;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--action:active {
    background: #185309;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--action:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--progressive {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: #0276b1;
    border: 0;
    color: #ffffff;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--progressive {
      min-width: 88px;
    }
  }

  .grv-button--progressive:visited {
    color: #ffffff;
  }

  .grv-button--progressive:hover {
    background: #026597;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--progressive:active {
    background: #014e74;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--progressive:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--regressive {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: #696969;
    border: 0;
    color: #ffffff;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--regressive {
      min-width: 88px;
    }
  }

  .grv-button--regressive:visited {
    color: #ffffff;
  }

  .grv-button--regressive:hover {
    background: #525252;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--regressive:active {
    background: #3d3d3d;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--regressive:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--destructive {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: #cc2427;
    border: 0;
    color: #ffffff;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--destructive {
      min-width: 88px;
    }
  }

  .grv-button--destructive:visited {
    color: #ffffff;
  }

  .grv-button--destructive:hover {
    background: #ba2629;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--destructive:active {
    background: #a3282b;
    color: #ffffff;
    text-decoration: none;
  }

  .grv-button--destructive:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--ghost {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: transparent;
    border: 0;
    color: #ffffff;
    border: 2px solid #ffffff;
    line-height: 44px;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--ghost {
      min-width: 88px;
    }
  }

  .grv-button--ghost:visited {
    color: #ffffff;
  }

  .grv-button--ghost:hover {
    background: #ffffff;
    color: #141414;
    text-decoration: none;
  }

  .grv-button--ghost:active {
    background: #ffffff;
    color: #141414;
    text-decoration: none;
  }

  .grv-button--ghost:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
  }

  .grv-button--ghost.grv-button--compact {
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    height: 32px;
    min-width: 72px;
  }

  .grv-button--text {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: transparent;
    border: 0;
    color: #696969;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--text {
      min-width: 88px;
    }
  }

  .grv-button--text:visited {
    color: #696969;
  }

  .grv-button--text:hover {
    background: transparent;
    color: #141414;
    text-decoration: underline;
  }

  .grv-button--text:active {
    background: transparent;
    color: #141414;
    text-decoration: underline;
  }

  .grv-button--text:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
    background: transparent;
    text-decoration: none;
  }

  .grv-button--text-compact {
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    min-width: 100%;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    margin: 0;
    padding: 0 16px;
    -webkit-appearance: none;
    background: transparent;
    border: 0;
    color: #696969;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    line-height: 32px;
    height: 32px;
    min-width: 72px;
  }

  @media only screen and (min-width: 600px) {
    .grv-button--text-compact {
      min-width: 88px;
    }
  }

  .grv-button--text-compact:visited {
    color: #696969;
  }

  .grv-button--text-compact:hover {
    background: transparent;
    color: #141414;
    text-decoration: underline;
  }

  .grv-button--text-compact:active {
    background: transparent;
    color: #141414;
    text-decoration: underline;
  }

  .grv-button--text-compact:disabled:not(.grv-button--loading-active) {
    color: #7d7d7d;
    background: #f4f4f4;
    border-color: #f4f4f4;
    cursor: not-allowed;
    background: transparent;
    text-decoration: none;
  }

  .grv-button--compact {
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    line-height: 32px;
    height: 32px;
    min-width: 72px;
  }

  .grv-button--compact.grv-button--loading {
    position: relative;
  }

  .grv-button--compact.grv-button--loading::after {
    -webkit-animation: grv-spinner__rotate 0.66s infinite ease-in-out, grv-spinner__load-out 0.1s linear;
    animation: grv-spinner__rotate 0.66s infinite ease-in-out, grv-spinner__load-out 0.1s linear;
    border: 2px solid #ffffff;
    border-radius: 100vh;
    border-top-color: transparent;
    box-sizing: border-box;
    content: '';
    display: block;
    height: 16px;
    opacity: 0;
    -ms-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -ms-transform: scale(1);
    transform: scale(1);
    width: 16px;
    display: none;
    left: 50%;
    margin-left: -8px;
    margin-top: -8px;
    top: 50%;
    z-index: 0;
  }

  @keyframes grv-spinner__load-in {
    0% {
      opacity: 0;
      transform: scale(0);
      -ms-transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
      -ms-transform: scale(1);
    }
  }
  @keyframes grv-spinner__load-out {
    0% {
      opacity: 1;
      transform: scale(1);
      -ms-transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(0);
      -ms-transform: scale(0);
    }
  }
  @keyframes grv-spinner__rotate {
    from {
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
      -ms-transform: rotate(360deg);
    }
  }

  .grv-button--compact.grv-button--loading-active {
    vertical-align: top;
    font-size: 0;
  }

  .grv-button--compact.grv-button--loading-active::after {
    display: block;
    opacity: 1;
    position: absolute;
  }

  .grv-button--compact.grv-button--loading-active:disabled {
    cursor: not-allowed;
  }

  .grv-button--compact.grv-button--loading-active.grv-button--progressive {
    background-color: #014e74;
  }

  .grv-button--compact.grv-button--loading-active.grv-button--action {
    background-color: #005128;
  }

  .grv-button--compact.grv-button--loading-active.grv-button--regressive {
    background-color: #3d3d3d;
  }

  .grv-button--compact.grv-button--loading-active.grv-button--destructive {
    background-color: #a3282b;
  }

  .grv-button--compact.grv-button--loading-active.grv-button--ghost {
    background-color: #ffffff;
  }

  .grv-button--text-directional-left {
    background: transparent !important;
    border: 0;
    color: #0276b1;
    cursor: pointer;
    font-size: 16px;
    line-height: 32px;
    height: auto;
    min-width: initial;
    text-decoration: none;
    padding: 0;
  }

  .grv-button--text-directional-left:visited {
    color: #0276b1;
  }

  .grv-button--text-directional-left:hover {
    color: #026597;
    text-decoration: underline;
  }

  .grv-button--text-directional-left:active {
    color: #014e74;
    text-decoration: underline;
  }

  .grv-button--text-directional-left:disabled {
    color: #7d7d7d;
    text-decoration: none;
  }

  .grv-button--text-directional-left::before {
    content: '';
    border: solid #0276b1;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-right: 8px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .grv-button--text-directional-left:visited {
    background: transparent;
  }

  .grv-button--text-directional-left:visited::before {
    border: solid #0276b1;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-right: 8px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .grv-button--text-directional-left:hover {
    background: transparent;
  }

  .grv-button--text-directional-left:hover::before {
    border: solid #026597;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-right: 8px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .grv-button--text-directional-left:active {
    background: transparent;
  }

  .grv-button--text-directional-left:active::before {
    border: solid #014e74;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-right: 8px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .grv-button--text-directional-left:disabled {
    background: transparent;
  }

  .grv-button--text-directional-left:disabled::before {
    border: solid #d4d4d4;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-right: 8px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .grv-button--text-directional-right {
    background: transparent !important;
    border: 0;
    color: #0276b1;
    cursor: pointer;
    font-size: 16px;
    line-height: 32px;
    height: auto;
    min-width: initial;
    text-decoration: none;
    padding: 0;
  }

  .grv-button--text-directional-right:visited {
    color: #0276b1;
  }

  .grv-button--text-directional-right:hover {
    color: #026597;
    text-decoration: underline;
  }

  .grv-button--text-directional-right:active {
    color: #014e74;
    text-decoration: underline;
  }

  .grv-button--text-directional-right:disabled {
    color: #7d7d7d;
    text-decoration: none;
  }

  .grv-button--text-directional-right::after {
    content: '';
    border: solid #0276b1;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-left: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .grv-button--text-directional-right:visited {
    background: transparent;
  }

  .grv-button--text-directional-right:visited::after {
    border: solid #0276b1;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-left: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .grv-button--text-directional-right:hover {
    background: transparent;
  }

  .grv-button--text-directional-right:hover::after {
    border: solid #026597;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-left: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .grv-button--text-directional-right:active {
    background: transparent;
  }

  .grv-button--text-directional-right:active::after {
    border: solid #014e74;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-left: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .grv-button--text-directional-right:disabled {
    background: transparent;
  }

  .grv-button--text-directional-right:disabled::after {
    border: solid #d4d4d4;
    border-width: 0 2px 2px 0;
    content: '';
    display: inline-block;
    padding: 2px;
    position: relative;
    top: -2px;
    margin-left: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .grv-button--loading {
    position: relative;
  }

  .grv-button--loading::after {
    -webkit-animation: grv-spinner__rotate 0.66s infinite ease-in-out, grv-spinner__load-out 0.1s linear;
    animation: grv-spinner__rotate 0.66s infinite ease-in-out, grv-spinner__load-out 0.1s linear;
    border: 2px solid #ffffff;
    border-radius: 100vh;
    border-top-color: transparent;
    box-sizing: border-box;
    content: '';
    display: block;
    height: 28px;
    opacity: 0;
    -ms-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -ms-transform: scale(1);
    transform: scale(1);
    width: 28px;
    display: none;
    left: 50%;
    margin-left: -14px;
    margin-top: -14px;
    top: 50%;
    z-index: 0;
  }

  .grv-button--loading-active {
    vertical-align: top;
    font-size: 0;
  }

  .grv-button--loading-active::after {
    display: block;
    opacity: 1;
    position: absolute;
  }

  .grv-button--loading-active:disabled {
    cursor: not-allowed;
  }

  .grv-button--loading-active.grv-button--progressive {
    background-color: #014e74;
  }

  .grv-button--loading-active.grv-button--action {
    background-color: #005128;
  }

  .grv-button--loading-active.grv-button--regressive {
    background-color: #3d3d3d;
  }

  .grv-button--loading-active.grv-button--destructive {
    background-color: #a3282b;
  }

  .grv-button--loading-active.grv-button--ghost {
    background-color: #ffffff;
  }

  .grv-button__announce {
    display: none;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    width: 1px;
    overflow: hidden;
    position: absolute !important;
    font-size: 16px;
  }

  .grv-button__announce--active {
    display: inline;
  }
`;

export const gravityElevation = css`
  /* prettier-ignore */
  .grv-elevation {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }

  .grv-elevation--none {
    box-shadow: none;
  }

  .grv-elevation--level-1 {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }

  .grv-elevation--level-2 {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .grv-elevation--level-3 {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const gravityGrid = css`
  /* prettier-ignore */
  .grv-wrapper {
    margin: 0 auto;
    max-width: 1216px;
  }

  .grv-col,
  [class*='grv-col--'] {
    box-sizing: border-box;
    display: block;
    max-width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    -webkit-flex-basis: auto;
    -moz-flex-basis: auto;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -moz-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-flex-shrink: 0;
    -moz-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  @media only screen and (min-width: 1024px) {
    .grv-col,
    [class*='grv-col--'] {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  .grv-col .grv-row,
  [class*='grv-col--'] .grv-row {
    margin-left: -8px;
    margin-right: -8px;
  }

  @media only screen and (min-width: 1024px) {
    .grv-col .grv-row,
    [class*='grv-col--'] .grv-row {
      margin-left: -16px;
      margin-right: -16px;
    }
  }

  .grv-grid .grv-col .grv-row,
  .grv-grid [class*='grv-col--'] .grv-row {
    padding-left: 0;
    padding-right: 0;
  }

  .grv-grid {
    box-sizing: border-box;
  }

  .grv-grid .grv-row {
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 0;
    -webkit-flex: 0 1 auto;
    -moz-box-flex: 0;
    -moz-flex: 0 1 auto;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .grv-grid .grv-row {
    padding-left: 16px;
    padding-right: 16px;
  }

  .grv-grid .grv-row--xs-around {
    -ms-flex-pack: distribute;
    -webkit-justify-content: space-around;
    -moz-justify-content: space-around;
    justify-content: space-around;
  }

  .grv-grid .grv-row--xs-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    justify-content: space-between;
  }

  .grv-grid .grv-row--xs-start,
  .grv-grid .grv-row--xs-left {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    -webkit-justify-content: flex-start;
    -moz-justify-content: flex-start;
    justify-content: flex-start;
  }

  .grv-grid .grv-row--xs-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    justify-content: center;
  }

  .grv-grid .grv-row--xs-end,
  .grv-grid .grv-row--xs-right {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    -moz-justify-content: flex-end;
    justify-content: flex-end;
  }

  .grv-grid .grv-row--xs-top {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    -moz-align-items: flex-start;
    align-items: flex-start;
  }

  .grv-grid .grv-row--xs-middle {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
  }

  .grv-grid .grv-row--xs-bottom {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    -moz-align-items: flex-end;
    align-items: flex-end;
  }

  .grv-grid .grv-row--xs-first {
    order: -1;
  }

  .grv-grid .grv-row--xs-last {
    order: 1;
  }

  .grv-grid .grv-row--xs-forward {
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .grv-grid .grv-row--xs-reverse {
    -webkit-box-direction: reverse;
    -webkit-box-orient: horizontal;
    -webkit-flex-direction: row-reverse;
    -moz-flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
  }

  .grv-grid .grv-col--xs-auto {
    max-width: 100%;
    -webkit-flex-basis: auto;
    -moz-flex-basis: auto;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -moz-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-flex-shrink: 0;
    -moz-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  .grv-grid .grv-col--xs-4 {
    max-width: 100%;
    -webkit-flex-basis: 100%;
    -moz-flex-basis: 100%;
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }

  .grv-grid .grv-col--xs-3 {
    max-width: 75%;
    -webkit-flex-basis: 75%;
    -moz-flex-basis: 75%;
    -ms-flex-preferred-size: 75%;
    flex-basis: 75%;
  }

  .grv-grid .grv-col--xs-2 {
    max-width: 50%;
    -webkit-flex-basis: 50%;
    -moz-flex-basis: 50%;
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
  }

  .grv-grid .grv-col--xs-1 {
    max-width: 25%;
    -webkit-flex-basis: 25%;
    -moz-flex-basis: 25%;
    -ms-flex-preferred-size: 25%;
    flex-basis: 25%;
  }

  .grv-grid .grv-col--xs-0 {
    display: none;
  }

  .grv-grid .grv-col--xs-offset-4 {
    margin-left: 100%;
  }

  .grv-grid .grv-col--xs-offset-3 {
    margin-left: 75%;
  }

  .grv-grid .grv-col--xs-offset-2 {
    margin-left: 50%;
  }

  .grv-grid .grv-col--xs-offset-1 {
    margin-left: 25%;
  }

  .grv-grid .grv-col--xs-offset-0 {
    margin-left: 0;
  }

  .grv-grid .grv-col--xs-order-4 {
    order: 4;
  }

  .grv-grid .grv-col--xs-order-3 {
    order: 3;
  }

  .grv-grid .grv-col--xs-order-2 {
    order: 2;
  }

  .grv-grid .grv-col--xs-order-1 {
    order: 1;
  }

  .grv-grid .grv-col--xs-order-0 {
    order: 0;
  }

  .grv-row__margin-fluid--xs--none,
  .grv-row__margin-fluid--xs--small-1,
  .grv-row__margin-fluid--xs--small-2,
  .grv-row__margin-fluid--xs--medium-1,
  .grv-row__margin-fluid--xs--medium-2,
  .grv-row__margin-fluid--xs--large-1,
  .grv-row__margin-fluid--xs--large-2,
  .grv-row__margin-fluid--xs--large-3,
  .grv-row__margin-fluid--xs--large-4,
  .grv-row__margin-fluid--xs--xlarge-1,
  .grv-row__margin-fluid--xs--xlarge-2,
  .grv-row__margin-fluid--xs--xlarge-3,
  .grv-row__margin-fluid--xs--xlarge-4,
  .grv-row__margin-fluid--xs--xlarge-5,
  .grv-row__margin-fluid--xs--tiny,
  .grv-row__margin-fluid--xs--small,
  .grv-row__margin-fluid--xs--normal,
  .grv-row__margin-fluid--xs--medium,
  .grv-row__margin-fluid--xs--large,
  .grv-row__margin-fluid--xs--xlarge,
  .grv-row__margin-fluid--xs--xxlarge {
    margin-bottom: 0px;
  }

  .grv-row__margin--xs--none,
  .grv-row__margin-fluid--xs--none > .grv-col,
  .grv-row__margin-fluid--xs--none > [class*='grv-col--'] {
    margin-bottom: 0px;
  }

  .grv-row__margin--xs--small-1,
  .grv-row__margin-fluid--xs--small-1 > .grv-col,
  .grv-row__margin-fluid--xs--small-1 > [class*='grv-col--'] {
    margin-bottom: 4px;
  }

  .grv-row__margin--xs--small-2,
  .grv-row__margin--xs--tiny,
  .grv-row__margin-fluid--xs--small-2 > .grv-col,
  .grv-row__margin-fluid--xs--tiny > .grv-col,
  .grv-row__margin-fluid--xs--small-2 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--tiny > [class*='grv-col--'] {
    margin-bottom: 8px;
  }

  .grv-row__margin--xs--medium-1,
  .grv-row__margin--xs--small,
  .grv-row__margin-fluid--xs--medium-1 > .grv-col,
  .grv-row__margin-fluid--xs--small > .grv-col,
  .grv-row__margin-fluid--xs--medium-1 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--small > [class*='grv-col--'] {
    margin-bottom: 16px;
  }

  .grv-row__margin--xs--medium-2,
  .grv-row__margin--xs--normal,
  .grv-row__margin-fluid--xs--medium-2 > .grv-col,
  .grv-row__margin-fluid--xs--normal > .grv-col,
  .grv-row__margin-fluid--xs--medium-2 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--normal > [class*='grv-col--'] {
    margin-bottom: 24px;
  }

  .grv-row__margin--xs--large-1,
  .grv-row__margin--xs--medium,
  .grv-row__margin-fluid--xs--large-1 > .grv-col,
  .grv-row__margin-fluid--xs--medium > .grv-col,
  .grv-row__margin-fluid--xs--large-1 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--medium > [class*='grv-col--'] {
    margin-bottom: 32px;
  }

  .grv-row__margin--xs--large-2,
  .grv-row__margin-fluid--xs--large-2 > .grv-col,
  .grv-row__margin-fluid--xs--large-2 > [class*='grv-col--'] {
    margin-bottom: 40px;
  }

  .grv-row__margin--xs--large-3,
  .grv-row__margin--xs--large,
  .grv-row__margin-fluid--xs--large-3 > .grv-col,
  .grv-row__margin-fluid--xs--large > .grv-col,
  .grv-row__margin-fluid--xs--large-3 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--large > [class*='grv-col--'] {
    margin-bottom: 48px;
  }

  .grv-row__margin--xs--large-4,
  .grv-row__margin-fluid--xs--large-4 > .grv-col,
  .grv-row__margin-fluid--xs--large-4 > [class*='grv-col--'] {
    margin-bottom: 56px;
  }

  .grv-row__margin--xs--xlarge-1,
  .grv-row__margin--xs--xlarge,
  .grv-row__margin-fluid--xs--xlarge-1 > .grv-col,
  .grv-row__margin-fluid--xs--xlarge > .grv-col,
  .grv-row__margin-fluid--xs--xlarge-1 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--xlarge > [class*='grv-col--'] {
    margin-bottom: 64px;
  }

  .grv-row__margin--xs--xlarge-2,
  .grv-row__margin-fluid--xs--xlarge-2 > .grv-col,
  .grv-row__margin-fluid--xs--xlarge-2 > [class*='grv-col--'] {
    margin-bottom: 72px;
  }

  .grv-row__margin--xs--xlarge-3,
  .grv-row__margin-fluid--xs--xlarge-3 > .grv-col,
  .grv-row__margin-fluid--xs--xlarge-3 > [class*='grv-col--'] {
    margin-bottom: 80px;
  }

  .grv-row__margin--xs--xlarge-4,
  .grv-row__margin-fluid--xs--xlarge-4 > .grv-col,
  .grv-row__margin-fluid--xs--xlarge-4 > [class*='grv-col--'] {
    margin-bottom: 88px;
  }

  .grv-row__margin--xs--xlarge-5,
  .grv-row__margin--xs--xxlarge,
  .grv-row__margin-fluid--xs--xlarge-5 > .grv-col,
  .grv-row__margin-fluid--xs--xxlarge > .grv-col,
  .grv-row__margin-fluid--xs--xlarge-5 > [class*='grv-col--'],
  .grv-row__margin-fluid--xs--xxlarge > [class*='grv-col--'] {
    margin-bottom: 96px;
  }

  .grv-grid .grv-report::after {
    content: 'xs';
  }

  @media only screen and (min-width: 369px) {
    .grv-grid .grv-row--sm-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--sm-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--sm-start,
    .grv-grid .grv-row--sm-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--sm-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--sm-end,
    .grv-grid .grv-row--sm-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--sm-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--sm-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--sm-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--sm-first {
      order: -1;
    }

    .grv-grid .grv-row--sm-last {
      order: 1;
    }

    .grv-grid .grv-row--sm-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--sm-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--sm-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--sm-4 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--sm-3 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--sm-2 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--sm-1 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--sm-0 {
      display: none;
    }

    .grv-grid .grv-col--sm-offset-4 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--sm-offset-3 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--sm-offset-2 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--sm-offset-1 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--sm-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--sm-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--sm-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--sm-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--sm-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--sm-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--sm--none,
    .grv-row__margin-fluid--sm--small-1,
    .grv-row__margin-fluid--sm--small-2,
    .grv-row__margin-fluid--sm--medium-1,
    .grv-row__margin-fluid--sm--medium-2,
    .grv-row__margin-fluid--sm--large-1,
    .grv-row__margin-fluid--sm--large-2,
    .grv-row__margin-fluid--sm--large-3,
    .grv-row__margin-fluid--sm--large-4,
    .grv-row__margin-fluid--sm--xlarge-1,
    .grv-row__margin-fluid--sm--xlarge-2,
    .grv-row__margin-fluid--sm--xlarge-3,
    .grv-row__margin-fluid--sm--xlarge-4,
    .grv-row__margin-fluid--sm--xlarge-5,
    .grv-row__margin-fluid--sm--tiny,
    .grv-row__margin-fluid--sm--small,
    .grv-row__margin-fluid--sm--normal,
    .grv-row__margin-fluid--sm--medium,
    .grv-row__margin-fluid--sm--large,
    .grv-row__margin-fluid--sm--xlarge,
    .grv-row__margin-fluid--sm--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--sm--none,
    .grv-row__margin-fluid--sm--none > .grv-col,
    .grv-row__margin-fluid--sm--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--sm--small-1,
    .grv-row__margin-fluid--sm--small-1 > .grv-col,
    .grv-row__margin-fluid--sm--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--sm--small-2,
    .grv-row__margin--sm--tiny,
    .grv-row__margin-fluid--sm--small-2 > .grv-col,
    .grv-row__margin-fluid--sm--tiny > .grv-col,
    .grv-row__margin-fluid--sm--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--sm--medium-1,
    .grv-row__margin--sm--small,
    .grv-row__margin-fluid--sm--medium-1 > .grv-col,
    .grv-row__margin-fluid--sm--small > .grv-col,
    .grv-row__margin-fluid--sm--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--sm--medium-2,
    .grv-row__margin--sm--normal,
    .grv-row__margin-fluid--sm--medium-2 > .grv-col,
    .grv-row__margin-fluid--sm--normal > .grv-col,
    .grv-row__margin-fluid--sm--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--sm--large-1,
    .grv-row__margin--sm--medium,
    .grv-row__margin-fluid--sm--large-1 > .grv-col,
    .grv-row__margin-fluid--sm--medium > .grv-col,
    .grv-row__margin-fluid--sm--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--sm--large-2,
    .grv-row__margin-fluid--sm--large-2 > .grv-col,
    .grv-row__margin-fluid--sm--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--sm--large-3,
    .grv-row__margin--sm--large,
    .grv-row__margin-fluid--sm--large-3 > .grv-col,
    .grv-row__margin-fluid--sm--large > .grv-col,
    .grv-row__margin-fluid--sm--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--sm--large-4,
    .grv-row__margin-fluid--sm--large-4 > .grv-col,
    .grv-row__margin-fluid--sm--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--sm--xlarge-1,
    .grv-row__margin--sm--xlarge,
    .grv-row__margin-fluid--sm--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--sm--xlarge > .grv-col,
    .grv-row__margin-fluid--sm--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--sm--xlarge-2,
    .grv-row__margin-fluid--sm--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--sm--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--sm--xlarge-3,
    .grv-row__margin-fluid--sm--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--sm--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--sm--xlarge-4,
    .grv-row__margin-fluid--sm--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--sm--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--sm--xlarge-5,
    .grv-row__margin--sm--xxlarge,
    .grv-row__margin-fluid--sm--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--sm--xxlarge > .grv-col,
    .grv-row__margin-fluid--sm--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--sm--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'sm';
    }
  }
  @media only screen and (min-width: 600px) {
    .grv-grid .grv-row {
      padding-left: 40px;
      padding-right: 40px;
    }

    .grv-grid .grv-row--md-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--md-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--md-start,
    .grv-grid .grv-row--md-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--md-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--md-end,
    .grv-grid .grv-row--md-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--md-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--md-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--md-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--md-first {
      order: -1;
    }

    .grv-grid .grv-row--md-last {
      order: 1;
    }

    .grv-grid .grv-row--md-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--md-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--md-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--md-8 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--md-7 {
      max-width: 87.5%;
      -webkit-flex-basis: 87.5%;
      -moz-flex-basis: 87.5%;
      -ms-flex-preferred-size: 87.5%;
      flex-basis: 87.5%;
    }

    .grv-grid .grv-col--md-6 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--md-5 {
      max-width: 62.5%;
      -webkit-flex-basis: 62.5%;
      -moz-flex-basis: 62.5%;
      -ms-flex-preferred-size: 62.5%;
      flex-basis: 62.5%;
    }

    .grv-grid .grv-col--md-4 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--md-3 {
      max-width: 37.5%;
      -webkit-flex-basis: 37.5%;
      -moz-flex-basis: 37.5%;
      -ms-flex-preferred-size: 37.5%;
      flex-basis: 37.5%;
    }

    .grv-grid .grv-col--md-2 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--md-1 {
      max-width: 12.5%;
      -webkit-flex-basis: 12.5%;
      -moz-flex-basis: 12.5%;
      -ms-flex-preferred-size: 12.5%;
      flex-basis: 12.5%;
    }

    .grv-grid .grv-col--md-0 {
      display: none;
    }

    .grv-grid .grv-col--md-offset-8 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--md-offset-7 {
      margin-left: 87.5%;
    }

    .grv-grid .grv-col--md-offset-6 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--md-offset-5 {
      margin-left: 62.5%;
    }

    .grv-grid .grv-col--md-offset-4 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--md-offset-3 {
      margin-left: 37.5%;
    }

    .grv-grid .grv-col--md-offset-2 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--md-offset-1 {
      margin-left: 12.5%;
    }

    .grv-grid .grv-col--md-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--md-order-8 {
      order: 8;
    }

    .grv-grid .grv-col--md-order-7 {
      order: 7;
    }

    .grv-grid .grv-col--md-order-6 {
      order: 6;
    }

    .grv-grid .grv-col--md-order-5 {
      order: 5;
    }

    .grv-grid .grv-col--md-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--md-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--md-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--md-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--md-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--md--none,
    .grv-row__margin-fluid--md--small-1,
    .grv-row__margin-fluid--md--small-2,
    .grv-row__margin-fluid--md--medium-1,
    .grv-row__margin-fluid--md--medium-2,
    .grv-row__margin-fluid--md--large-1,
    .grv-row__margin-fluid--md--large-2,
    .grv-row__margin-fluid--md--large-3,
    .grv-row__margin-fluid--md--large-4,
    .grv-row__margin-fluid--md--xlarge-1,
    .grv-row__margin-fluid--md--xlarge-2,
    .grv-row__margin-fluid--md--xlarge-3,
    .grv-row__margin-fluid--md--xlarge-4,
    .grv-row__margin-fluid--md--xlarge-5,
    .grv-row__margin-fluid--md--tiny,
    .grv-row__margin-fluid--md--small,
    .grv-row__margin-fluid--md--normal,
    .grv-row__margin-fluid--md--medium,
    .grv-row__margin-fluid--md--large,
    .grv-row__margin-fluid--md--xlarge,
    .grv-row__margin-fluid--md--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--md--none,
    .grv-row__margin-fluid--md--none > .grv-col,
    .grv-row__margin-fluid--md--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--md--small-1,
    .grv-row__margin-fluid--md--small-1 > .grv-col,
    .grv-row__margin-fluid--md--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--md--small-2,
    .grv-row__margin--md--tiny,
    .grv-row__margin-fluid--md--small-2 > .grv-col,
    .grv-row__margin-fluid--md--tiny > .grv-col,
    .grv-row__margin-fluid--md--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--md--medium-1,
    .grv-row__margin--md--small,
    .grv-row__margin-fluid--md--medium-1 > .grv-col,
    .grv-row__margin-fluid--md--small > .grv-col,
    .grv-row__margin-fluid--md--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--md--medium-2,
    .grv-row__margin--md--normal,
    .grv-row__margin-fluid--md--medium-2 > .grv-col,
    .grv-row__margin-fluid--md--normal > .grv-col,
    .grv-row__margin-fluid--md--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--md--large-1,
    .grv-row__margin--md--medium,
    .grv-row__margin-fluid--md--large-1 > .grv-col,
    .grv-row__margin-fluid--md--medium > .grv-col,
    .grv-row__margin-fluid--md--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--md--large-2,
    .grv-row__margin-fluid--md--large-2 > .grv-col,
    .grv-row__margin-fluid--md--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--md--large-3,
    .grv-row__margin--md--large,
    .grv-row__margin-fluid--md--large-3 > .grv-col,
    .grv-row__margin-fluid--md--large > .grv-col,
    .grv-row__margin-fluid--md--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--md--large-4,
    .grv-row__margin-fluid--md--large-4 > .grv-col,
    .grv-row__margin-fluid--md--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--md--xlarge-1,
    .grv-row__margin--md--xlarge,
    .grv-row__margin-fluid--md--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--md--xlarge > .grv-col,
    .grv-row__margin-fluid--md--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--md--xlarge-2,
    .grv-row__margin-fluid--md--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--md--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--md--xlarge-3,
    .grv-row__margin-fluid--md--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--md--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--md--xlarge-4,
    .grv-row__margin-fluid--md--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--md--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--md--xlarge-5,
    .grv-row__margin--md--xxlarge,
    .grv-row__margin-fluid--md--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--md--xxlarge > .grv-col,
    .grv-row__margin-fluid--md--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--md--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'md';
    }
  }
  @media only screen and (min-width: 768px) {
    .grv-grid .grv-row--ml-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--ml-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--ml-start,
    .grv-grid .grv-row--ml-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--ml-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--ml-end,
    .grv-grid .grv-row--ml-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--ml-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--ml-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--ml-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--ml-first {
      order: -1;
    }

    .grv-grid .grv-row--ml-last {
      order: 1;
    }

    .grv-grid .grv-row--ml-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--ml-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--ml-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--ml-8 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--ml-7 {
      max-width: 87.5%;
      -webkit-flex-basis: 87.5%;
      -moz-flex-basis: 87.5%;
      -ms-flex-preferred-size: 87.5%;
      flex-basis: 87.5%;
    }

    .grv-grid .grv-col--ml-6 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--ml-5 {
      max-width: 62.5%;
      -webkit-flex-basis: 62.5%;
      -moz-flex-basis: 62.5%;
      -ms-flex-preferred-size: 62.5%;
      flex-basis: 62.5%;
    }

    .grv-grid .grv-col--ml-4 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--ml-3 {
      max-width: 37.5%;
      -webkit-flex-basis: 37.5%;
      -moz-flex-basis: 37.5%;
      -ms-flex-preferred-size: 37.5%;
      flex-basis: 37.5%;
    }

    .grv-grid .grv-col--ml-2 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--ml-1 {
      max-width: 12.5%;
      -webkit-flex-basis: 12.5%;
      -moz-flex-basis: 12.5%;
      -ms-flex-preferred-size: 12.5%;
      flex-basis: 12.5%;
    }

    .grv-grid .grv-col--ml-0 {
      display: none;
    }

    .grv-grid .grv-col--ml-offset-8 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--ml-offset-7 {
      margin-left: 87.5%;
    }

    .grv-grid .grv-col--ml-offset-6 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--ml-offset-5 {
      margin-left: 62.5%;
    }

    .grv-grid .grv-col--ml-offset-4 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--ml-offset-3 {
      margin-left: 37.5%;
    }

    .grv-grid .grv-col--ml-offset-2 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--ml-offset-1 {
      margin-left: 12.5%;
    }

    .grv-grid .grv-col--ml-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--ml-order-8 {
      order: 8;
    }

    .grv-grid .grv-col--ml-order-7 {
      order: 7;
    }

    .grv-grid .grv-col--ml-order-6 {
      order: 6;
    }

    .grv-grid .grv-col--ml-order-5 {
      order: 5;
    }

    .grv-grid .grv-col--ml-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--ml-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--ml-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--ml-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--ml-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--ml--none,
    .grv-row__margin-fluid--ml--small-1,
    .grv-row__margin-fluid--ml--small-2,
    .grv-row__margin-fluid--ml--medium-1,
    .grv-row__margin-fluid--ml--medium-2,
    .grv-row__margin-fluid--ml--large-1,
    .grv-row__margin-fluid--ml--large-2,
    .grv-row__margin-fluid--ml--large-3,
    .grv-row__margin-fluid--ml--large-4,
    .grv-row__margin-fluid--ml--xlarge-1,
    .grv-row__margin-fluid--ml--xlarge-2,
    .grv-row__margin-fluid--ml--xlarge-3,
    .grv-row__margin-fluid--ml--xlarge-4,
    .grv-row__margin-fluid--ml--xlarge-5,
    .grv-row__margin-fluid--ml--tiny,
    .grv-row__margin-fluid--ml--small,
    .grv-row__margin-fluid--ml--normal,
    .grv-row__margin-fluid--ml--medium,
    .grv-row__margin-fluid--ml--large,
    .grv-row__margin-fluid--ml--xlarge,
    .grv-row__margin-fluid--ml--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--ml--none,
    .grv-row__margin-fluid--ml--none > .grv-col,
    .grv-row__margin-fluid--ml--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--ml--small-1,
    .grv-row__margin-fluid--ml--small-1 > .grv-col,
    .grv-row__margin-fluid--ml--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--ml--small-2,
    .grv-row__margin--ml--tiny,
    .grv-row__margin-fluid--ml--small-2 > .grv-col,
    .grv-row__margin-fluid--ml--tiny > .grv-col,
    .grv-row__margin-fluid--ml--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--ml--medium-1,
    .grv-row__margin--ml--small,
    .grv-row__margin-fluid--ml--medium-1 > .grv-col,
    .grv-row__margin-fluid--ml--small > .grv-col,
    .grv-row__margin-fluid--ml--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--ml--medium-2,
    .grv-row__margin--ml--normal,
    .grv-row__margin-fluid--ml--medium-2 > .grv-col,
    .grv-row__margin-fluid--ml--normal > .grv-col,
    .grv-row__margin-fluid--ml--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--ml--large-1,
    .grv-row__margin--ml--medium,
    .grv-row__margin-fluid--ml--large-1 > .grv-col,
    .grv-row__margin-fluid--ml--medium > .grv-col,
    .grv-row__margin-fluid--ml--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--ml--large-2,
    .grv-row__margin-fluid--ml--large-2 > .grv-col,
    .grv-row__margin-fluid--ml--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--ml--large-3,
    .grv-row__margin--ml--large,
    .grv-row__margin-fluid--ml--large-3 > .grv-col,
    .grv-row__margin-fluid--ml--large > .grv-col,
    .grv-row__margin-fluid--ml--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--ml--large-4,
    .grv-row__margin-fluid--ml--large-4 > .grv-col,
    .grv-row__margin-fluid--ml--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--ml--xlarge-1,
    .grv-row__margin--ml--xlarge,
    .grv-row__margin-fluid--ml--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--ml--xlarge > .grv-col,
    .grv-row__margin-fluid--ml--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--ml--xlarge-2,
    .grv-row__margin-fluid--ml--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--ml--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--ml--xlarge-3,
    .grv-row__margin-fluid--ml--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--ml--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--ml--xlarge-4,
    .grv-row__margin-fluid--ml--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--ml--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--ml--xlarge-5,
    .grv-row__margin--ml--xxlarge,
    .grv-row__margin-fluid--ml--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--ml--xxlarge > .grv-col,
    .grv-row__margin-fluid--ml--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--ml--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'ml';
    }
  }
  @media only screen and (min-width: 1024px) {
    .grv-grid .grv-row {
      padding-left: 32px;
      padding-right: 32px;
    }

    .grv-grid .grv-row--lg-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--lg-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--lg-start,
    .grv-grid .grv-row--lg-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--lg-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--lg-end,
    .grv-grid .grv-row--lg-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--lg-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--lg-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--lg-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--lg-first {
      order: -1;
    }

    .grv-grid .grv-row--lg-last {
      order: 1;
    }

    .grv-grid .grv-row--lg-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--lg-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--lg-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--lg-12 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--lg-11 {
      max-width: 91.6666666667%;
      -webkit-flex-basis: 91.6666666667%;
      -moz-flex-basis: 91.6666666667%;
      -ms-flex-preferred-size: 91.6666666667%;
      flex-basis: 91.6666666667%;
    }

    .grv-grid .grv-col--lg-10 {
      max-width: 83.3333333333%;
      -webkit-flex-basis: 83.3333333333%;
      -moz-flex-basis: 83.3333333333%;
      -ms-flex-preferred-size: 83.3333333333%;
      flex-basis: 83.3333333333%;
    }

    .grv-grid .grv-col--lg-9 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--lg-8 {
      max-width: 66.6666666667%;
      -webkit-flex-basis: 66.6666666667%;
      -moz-flex-basis: 66.6666666667%;
      -ms-flex-preferred-size: 66.6666666667%;
      flex-basis: 66.6666666667%;
    }

    .grv-grid .grv-col--lg-7 {
      max-width: 58.3333333333%;
      -webkit-flex-basis: 58.3333333333%;
      -moz-flex-basis: 58.3333333333%;
      -ms-flex-preferred-size: 58.3333333333%;
      flex-basis: 58.3333333333%;
    }

    .grv-grid .grv-col--lg-6 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--lg-5 {
      max-width: 41.6666666667%;
      -webkit-flex-basis: 41.6666666667%;
      -moz-flex-basis: 41.6666666667%;
      -ms-flex-preferred-size: 41.6666666667%;
      flex-basis: 41.6666666667%;
    }

    .grv-grid .grv-col--lg-4 {
      max-width: 33.3333333333%;
      -webkit-flex-basis: 33.3333333333%;
      -moz-flex-basis: 33.3333333333%;
      -ms-flex-preferred-size: 33.3333333333%;
      flex-basis: 33.3333333333%;
    }

    .grv-grid .grv-col--lg-3 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--lg-2 {
      max-width: 16.6666666667%;
      -webkit-flex-basis: 16.6666666667%;
      -moz-flex-basis: 16.6666666667%;
      -ms-flex-preferred-size: 16.6666666667%;
      flex-basis: 16.6666666667%;
    }

    .grv-grid .grv-col--lg-1 {
      max-width: 8.3333333333%;
      -webkit-flex-basis: 8.3333333333%;
      -moz-flex-basis: 8.3333333333%;
      -ms-flex-preferred-size: 8.3333333333%;
      flex-basis: 8.3333333333%;
    }

    .grv-grid .grv-col--lg-0 {
      display: none;
    }

    .grv-grid .grv-col--lg-offset-12 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--lg-offset-11 {
      margin-left: 91.6666666667%;
    }

    .grv-grid .grv-col--lg-offset-10 {
      margin-left: 83.3333333333%;
    }

    .grv-grid .grv-col--lg-offset-9 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--lg-offset-8 {
      margin-left: 66.6666666667%;
    }

    .grv-grid .grv-col--lg-offset-7 {
      margin-left: 58.3333333333%;
    }

    .grv-grid .grv-col--lg-offset-6 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--lg-offset-5 {
      margin-left: 41.6666666667%;
    }

    .grv-grid .grv-col--lg-offset-4 {
      margin-left: 33.3333333333%;
    }

    .grv-grid .grv-col--lg-offset-3 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--lg-offset-2 {
      margin-left: 16.6666666667%;
    }

    .grv-grid .grv-col--lg-offset-1 {
      margin-left: 8.3333333333%;
    }

    .grv-grid .grv-col--lg-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--lg-order-12 {
      order: 12;
    }

    .grv-grid .grv-col--lg-order-11 {
      order: 11;
    }

    .grv-grid .grv-col--lg-order-10 {
      order: 10;
    }

    .grv-grid .grv-col--lg-order-9 {
      order: 9;
    }

    .grv-grid .grv-col--lg-order-8 {
      order: 8;
    }

    .grv-grid .grv-col--lg-order-7 {
      order: 7;
    }

    .grv-grid .grv-col--lg-order-6 {
      order: 6;
    }

    .grv-grid .grv-col--lg-order-5 {
      order: 5;
    }

    .grv-grid .grv-col--lg-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--lg-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--lg-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--lg-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--lg-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--lg--none,
    .grv-row__margin-fluid--lg--small-1,
    .grv-row__margin-fluid--lg--small-2,
    .grv-row__margin-fluid--lg--medium-1,
    .grv-row__margin-fluid--lg--medium-2,
    .grv-row__margin-fluid--lg--large-1,
    .grv-row__margin-fluid--lg--large-2,
    .grv-row__margin-fluid--lg--large-3,
    .grv-row__margin-fluid--lg--large-4,
    .grv-row__margin-fluid--lg--xlarge-1,
    .grv-row__margin-fluid--lg--xlarge-2,
    .grv-row__margin-fluid--lg--xlarge-3,
    .grv-row__margin-fluid--lg--xlarge-4,
    .grv-row__margin-fluid--lg--xlarge-5,
    .grv-row__margin-fluid--lg--tiny,
    .grv-row__margin-fluid--lg--small,
    .grv-row__margin-fluid--lg--normal,
    .grv-row__margin-fluid--lg--medium,
    .grv-row__margin-fluid--lg--large,
    .grv-row__margin-fluid--lg--xlarge,
    .grv-row__margin-fluid--lg--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--lg--none,
    .grv-row__margin-fluid--lg--none > .grv-col,
    .grv-row__margin-fluid--lg--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--lg--small-1,
    .grv-row__margin-fluid--lg--small-1 > .grv-col,
    .grv-row__margin-fluid--lg--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--lg--small-2,
    .grv-row__margin--lg--tiny,
    .grv-row__margin-fluid--lg--small-2 > .grv-col,
    .grv-row__margin-fluid--lg--tiny > .grv-col,
    .grv-row__margin-fluid--lg--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--lg--medium-1,
    .grv-row__margin--lg--small,
    .grv-row__margin-fluid--lg--medium-1 > .grv-col,
    .grv-row__margin-fluid--lg--small > .grv-col,
    .grv-row__margin-fluid--lg--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--lg--medium-2,
    .grv-row__margin--lg--normal,
    .grv-row__margin-fluid--lg--medium-2 > .grv-col,
    .grv-row__margin-fluid--lg--normal > .grv-col,
    .grv-row__margin-fluid--lg--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--lg--large-1,
    .grv-row__margin--lg--medium,
    .grv-row__margin-fluid--lg--large-1 > .grv-col,
    .grv-row__margin-fluid--lg--medium > .grv-col,
    .grv-row__margin-fluid--lg--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--lg--large-2,
    .grv-row__margin-fluid--lg--large-2 > .grv-col,
    .grv-row__margin-fluid--lg--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--lg--large-3,
    .grv-row__margin--lg--large,
    .grv-row__margin-fluid--lg--large-3 > .grv-col,
    .grv-row__margin-fluid--lg--large > .grv-col,
    .grv-row__margin-fluid--lg--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--lg--large-4,
    .grv-row__margin-fluid--lg--large-4 > .grv-col,
    .grv-row__margin-fluid--lg--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--lg--xlarge-1,
    .grv-row__margin--lg--xlarge,
    .grv-row__margin-fluid--lg--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--lg--xlarge > .grv-col,
    .grv-row__margin-fluid--lg--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--lg--xlarge-2,
    .grv-row__margin-fluid--lg--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--lg--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--lg--xlarge-3,
    .grv-row__margin-fluid--lg--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--lg--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--lg--xlarge-4,
    .grv-row__margin-fluid--lg--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--lg--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--lg--xlarge-5,
    .grv-row__margin--lg--xxlarge,
    .grv-row__margin-fluid--lg--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--lg--xxlarge > .grv-col,
    .grv-row__margin-fluid--lg--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--lg--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'lg';
    }
  }
  @media only screen and (min-width: 1200px) {
    .grv-grid .grv-row--xl-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--xl-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--xl-start,
    .grv-grid .grv-row--xl-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--xl-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--xl-end,
    .grv-grid .grv-row--xl-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--xl-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--xl-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--xl-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--xl-first {
      order: -1;
    }

    .grv-grid .grv-row--xl-last {
      order: 1;
    }

    .grv-grid .grv-row--xl-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--xl-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--xl-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--xl-12 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--xl-11 {
      max-width: 91.6666666667%;
      -webkit-flex-basis: 91.6666666667%;
      -moz-flex-basis: 91.6666666667%;
      -ms-flex-preferred-size: 91.6666666667%;
      flex-basis: 91.6666666667%;
    }

    .grv-grid .grv-col--xl-10 {
      max-width: 83.3333333333%;
      -webkit-flex-basis: 83.3333333333%;
      -moz-flex-basis: 83.3333333333%;
      -ms-flex-preferred-size: 83.3333333333%;
      flex-basis: 83.3333333333%;
    }

    .grv-grid .grv-col--xl-9 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--xl-8 {
      max-width: 66.6666666667%;
      -webkit-flex-basis: 66.6666666667%;
      -moz-flex-basis: 66.6666666667%;
      -ms-flex-preferred-size: 66.6666666667%;
      flex-basis: 66.6666666667%;
    }

    .grv-grid .grv-col--xl-7 {
      max-width: 58.3333333333%;
      -webkit-flex-basis: 58.3333333333%;
      -moz-flex-basis: 58.3333333333%;
      -ms-flex-preferred-size: 58.3333333333%;
      flex-basis: 58.3333333333%;
    }

    .grv-grid .grv-col--xl-6 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--xl-5 {
      max-width: 41.6666666667%;
      -webkit-flex-basis: 41.6666666667%;
      -moz-flex-basis: 41.6666666667%;
      -ms-flex-preferred-size: 41.6666666667%;
      flex-basis: 41.6666666667%;
    }

    .grv-grid .grv-col--xl-4 {
      max-width: 33.3333333333%;
      -webkit-flex-basis: 33.3333333333%;
      -moz-flex-basis: 33.3333333333%;
      -ms-flex-preferred-size: 33.3333333333%;
      flex-basis: 33.3333333333%;
    }

    .grv-grid .grv-col--xl-3 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--xl-2 {
      max-width: 16.6666666667%;
      -webkit-flex-basis: 16.6666666667%;
      -moz-flex-basis: 16.6666666667%;
      -ms-flex-preferred-size: 16.6666666667%;
      flex-basis: 16.6666666667%;
    }

    .grv-grid .grv-col--xl-1 {
      max-width: 8.3333333333%;
      -webkit-flex-basis: 8.3333333333%;
      -moz-flex-basis: 8.3333333333%;
      -ms-flex-preferred-size: 8.3333333333%;
      flex-basis: 8.3333333333%;
    }

    .grv-grid .grv-col--xl-0 {
      display: none;
    }

    .grv-grid .grv-col--xl-offset-12 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--xl-offset-11 {
      margin-left: 91.6666666667%;
    }

    .grv-grid .grv-col--xl-offset-10 {
      margin-left: 83.3333333333%;
    }

    .grv-grid .grv-col--xl-offset-9 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--xl-offset-8 {
      margin-left: 66.6666666667%;
    }

    .grv-grid .grv-col--xl-offset-7 {
      margin-left: 58.3333333333%;
    }

    .grv-grid .grv-col--xl-offset-6 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--xl-offset-5 {
      margin-left: 41.6666666667%;
    }

    .grv-grid .grv-col--xl-offset-4 {
      margin-left: 33.3333333333%;
    }

    .grv-grid .grv-col--xl-offset-3 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--xl-offset-2 {
      margin-left: 16.6666666667%;
    }

    .grv-grid .grv-col--xl-offset-1 {
      margin-left: 8.3333333333%;
    }

    .grv-grid .grv-col--xl-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--xl-order-12 {
      order: 12;
    }

    .grv-grid .grv-col--xl-order-11 {
      order: 11;
    }

    .grv-grid .grv-col--xl-order-10 {
      order: 10;
    }

    .grv-grid .grv-col--xl-order-9 {
      order: 9;
    }

    .grv-grid .grv-col--xl-order-8 {
      order: 8;
    }

    .grv-grid .grv-col--xl-order-7 {
      order: 7;
    }

    .grv-grid .grv-col--xl-order-6 {
      order: 6;
    }

    .grv-grid .grv-col--xl-order-5 {
      order: 5;
    }

    .grv-grid .grv-col--xl-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--xl-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--xl-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--xl-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--xl-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--xl--none,
    .grv-row__margin-fluid--xl--small-1,
    .grv-row__margin-fluid--xl--small-2,
    .grv-row__margin-fluid--xl--medium-1,
    .grv-row__margin-fluid--xl--medium-2,
    .grv-row__margin-fluid--xl--large-1,
    .grv-row__margin-fluid--xl--large-2,
    .grv-row__margin-fluid--xl--large-3,
    .grv-row__margin-fluid--xl--large-4,
    .grv-row__margin-fluid--xl--xlarge-1,
    .grv-row__margin-fluid--xl--xlarge-2,
    .grv-row__margin-fluid--xl--xlarge-3,
    .grv-row__margin-fluid--xl--xlarge-4,
    .grv-row__margin-fluid--xl--xlarge-5,
    .grv-row__margin-fluid--xl--tiny,
    .grv-row__margin-fluid--xl--small,
    .grv-row__margin-fluid--xl--normal,
    .grv-row__margin-fluid--xl--medium,
    .grv-row__margin-fluid--xl--large,
    .grv-row__margin-fluid--xl--xlarge,
    .grv-row__margin-fluid--xl--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--xl--none,
    .grv-row__margin-fluid--xl--none > .grv-col,
    .grv-row__margin-fluid--xl--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--xl--small-1,
    .grv-row__margin-fluid--xl--small-1 > .grv-col,
    .grv-row__margin-fluid--xl--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--xl--small-2,
    .grv-row__margin--xl--tiny,
    .grv-row__margin-fluid--xl--small-2 > .grv-col,
    .grv-row__margin-fluid--xl--tiny > .grv-col,
    .grv-row__margin-fluid--xl--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--xl--medium-1,
    .grv-row__margin--xl--small,
    .grv-row__margin-fluid--xl--medium-1 > .grv-col,
    .grv-row__margin-fluid--xl--small > .grv-col,
    .grv-row__margin-fluid--xl--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--xl--medium-2,
    .grv-row__margin--xl--normal,
    .grv-row__margin-fluid--xl--medium-2 > .grv-col,
    .grv-row__margin-fluid--xl--normal > .grv-col,
    .grv-row__margin-fluid--xl--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--xl--large-1,
    .grv-row__margin--xl--medium,
    .grv-row__margin-fluid--xl--large-1 > .grv-col,
    .grv-row__margin-fluid--xl--medium > .grv-col,
    .grv-row__margin-fluid--xl--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--xl--large-2,
    .grv-row__margin-fluid--xl--large-2 > .grv-col,
    .grv-row__margin-fluid--xl--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--xl--large-3,
    .grv-row__margin--xl--large,
    .grv-row__margin-fluid--xl--large-3 > .grv-col,
    .grv-row__margin-fluid--xl--large > .grv-col,
    .grv-row__margin-fluid--xl--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--xl--large-4,
    .grv-row__margin-fluid--xl--large-4 > .grv-col,
    .grv-row__margin-fluid--xl--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--xl--xlarge-1,
    .grv-row__margin--xl--xlarge,
    .grv-row__margin-fluid--xl--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--xl--xlarge > .grv-col,
    .grv-row__margin-fluid--xl--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--xl--xlarge-2,
    .grv-row__margin-fluid--xl--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--xl--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--xl--xlarge-3,
    .grv-row__margin-fluid--xl--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--xl--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--xl--xlarge-4,
    .grv-row__margin-fluid--xl--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--xl--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--xl--xlarge-5,
    .grv-row__margin--xl--xxlarge,
    .grv-row__margin-fluid--xl--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--xl--xxlarge > .grv-col,
    .grv-row__margin-fluid--xl--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--xl--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'xl';
    }
  }
  @media only screen and (min-width: 1920px) {
    .grv-grid .grv-row--ds-around {
      -ms-flex-pack: distribute;
      -webkit-justify-content: space-around;
      -moz-justify-content: space-around;
      justify-content: space-around;
    }

    .grv-grid .grv-row--ds-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      justify-content: space-between;
    }

    .grv-grid .grv-row--ds-start,
    .grv-grid .grv-row--ds-left {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      justify-content: flex-start;
    }

    .grv-grid .grv-row--ds-center {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      justify-content: center;
    }

    .grv-grid .grv-row--ds-end,
    .grv-grid .grv-row--ds-right {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: flex-end;
      -moz-justify-content: flex-end;
      justify-content: flex-end;
    }

    .grv-grid .grv-row--ds-top {
      -webkit-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      align-items: flex-start;
    }

    .grv-grid .grv-row--ds-middle {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      align-items: center;
    }

    .grv-grid .grv-row--ds-bottom {
      -webkit-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      align-items: flex-end;
    }

    .grv-grid .grv-row--ds-first {
      order: -1;
    }

    .grv-grid .grv-row--ds-last {
      order: 1;
    }

    .grv-grid .grv-row--ds-forward {
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
    }

    .grv-grid .grv-row--ds-reverse {
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -webkit-flex-direction: row-reverse;
      -moz-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }

    .grv-grid .grv-col--ds-auto {
      max-width: 100%;
      -webkit-flex-basis: auto;
      -moz-flex-basis: auto;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -moz-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -webkit-flex-shrink: 0;
      -moz-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .grv-grid .grv-col--ds-12 {
      max-width: 100%;
      -webkit-flex-basis: 100%;
      -moz-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
    }

    .grv-grid .grv-col--ds-11 {
      max-width: 91.6666666667%;
      -webkit-flex-basis: 91.6666666667%;
      -moz-flex-basis: 91.6666666667%;
      -ms-flex-preferred-size: 91.6666666667%;
      flex-basis: 91.6666666667%;
    }

    .grv-grid .grv-col--ds-10 {
      max-width: 83.3333333333%;
      -webkit-flex-basis: 83.3333333333%;
      -moz-flex-basis: 83.3333333333%;
      -ms-flex-preferred-size: 83.3333333333%;
      flex-basis: 83.3333333333%;
    }

    .grv-grid .grv-col--ds-9 {
      max-width: 75%;
      -webkit-flex-basis: 75%;
      -moz-flex-basis: 75%;
      -ms-flex-preferred-size: 75%;
      flex-basis: 75%;
    }

    .grv-grid .grv-col--ds-8 {
      max-width: 66.6666666667%;
      -webkit-flex-basis: 66.6666666667%;
      -moz-flex-basis: 66.6666666667%;
      -ms-flex-preferred-size: 66.6666666667%;
      flex-basis: 66.6666666667%;
    }

    .grv-grid .grv-col--ds-7 {
      max-width: 58.3333333333%;
      -webkit-flex-basis: 58.3333333333%;
      -moz-flex-basis: 58.3333333333%;
      -ms-flex-preferred-size: 58.3333333333%;
      flex-basis: 58.3333333333%;
    }

    .grv-grid .grv-col--ds-6 {
      max-width: 50%;
      -webkit-flex-basis: 50%;
      -moz-flex-basis: 50%;
      -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
    }

    .grv-grid .grv-col--ds-5 {
      max-width: 41.6666666667%;
      -webkit-flex-basis: 41.6666666667%;
      -moz-flex-basis: 41.6666666667%;
      -ms-flex-preferred-size: 41.6666666667%;
      flex-basis: 41.6666666667%;
    }

    .grv-grid .grv-col--ds-4 {
      max-width: 33.3333333333%;
      -webkit-flex-basis: 33.3333333333%;
      -moz-flex-basis: 33.3333333333%;
      -ms-flex-preferred-size: 33.3333333333%;
      flex-basis: 33.3333333333%;
    }

    .grv-grid .grv-col--ds-3 {
      max-width: 25%;
      -webkit-flex-basis: 25%;
      -moz-flex-basis: 25%;
      -ms-flex-preferred-size: 25%;
      flex-basis: 25%;
    }

    .grv-grid .grv-col--ds-2 {
      max-width: 16.6666666667%;
      -webkit-flex-basis: 16.6666666667%;
      -moz-flex-basis: 16.6666666667%;
      -ms-flex-preferred-size: 16.6666666667%;
      flex-basis: 16.6666666667%;
    }

    .grv-grid .grv-col--ds-1 {
      max-width: 8.3333333333%;
      -webkit-flex-basis: 8.3333333333%;
      -moz-flex-basis: 8.3333333333%;
      -ms-flex-preferred-size: 8.3333333333%;
      flex-basis: 8.3333333333%;
    }

    .grv-grid .grv-col--ds-0 {
      display: none;
    }

    .grv-grid .grv-col--ds-offset-12 {
      margin-left: 100%;
    }

    .grv-grid .grv-col--ds-offset-11 {
      margin-left: 91.6666666667%;
    }

    .grv-grid .grv-col--ds-offset-10 {
      margin-left: 83.3333333333%;
    }

    .grv-grid .grv-col--ds-offset-9 {
      margin-left: 75%;
    }

    .grv-grid .grv-col--ds-offset-8 {
      margin-left: 66.6666666667%;
    }

    .grv-grid .grv-col--ds-offset-7 {
      margin-left: 58.3333333333%;
    }

    .grv-grid .grv-col--ds-offset-6 {
      margin-left: 50%;
    }

    .grv-grid .grv-col--ds-offset-5 {
      margin-left: 41.6666666667%;
    }

    .grv-grid .grv-col--ds-offset-4 {
      margin-left: 33.3333333333%;
    }

    .grv-grid .grv-col--ds-offset-3 {
      margin-left: 25%;
    }

    .grv-grid .grv-col--ds-offset-2 {
      margin-left: 16.6666666667%;
    }

    .grv-grid .grv-col--ds-offset-1 {
      margin-left: 8.3333333333%;
    }

    .grv-grid .grv-col--ds-offset-0 {
      margin-left: 0;
    }

    .grv-grid .grv-col--ds-order-12 {
      order: 12;
    }

    .grv-grid .grv-col--ds-order-11 {
      order: 11;
    }

    .grv-grid .grv-col--ds-order-10 {
      order: 10;
    }

    .grv-grid .grv-col--ds-order-9 {
      order: 9;
    }

    .grv-grid .grv-col--ds-order-8 {
      order: 8;
    }

    .grv-grid .grv-col--ds-order-7 {
      order: 7;
    }

    .grv-grid .grv-col--ds-order-6 {
      order: 6;
    }

    .grv-grid .grv-col--ds-order-5 {
      order: 5;
    }

    .grv-grid .grv-col--ds-order-4 {
      order: 4;
    }

    .grv-grid .grv-col--ds-order-3 {
      order: 3;
    }

    .grv-grid .grv-col--ds-order-2 {
      order: 2;
    }

    .grv-grid .grv-col--ds-order-1 {
      order: 1;
    }

    .grv-grid .grv-col--ds-order-0 {
      order: 0;
    }

    .grv-row__margin-fluid--ds--none,
    .grv-row__margin-fluid--ds--small-1,
    .grv-row__margin-fluid--ds--small-2,
    .grv-row__margin-fluid--ds--medium-1,
    .grv-row__margin-fluid--ds--medium-2,
    .grv-row__margin-fluid--ds--large-1,
    .grv-row__margin-fluid--ds--large-2,
    .grv-row__margin-fluid--ds--large-3,
    .grv-row__margin-fluid--ds--large-4,
    .grv-row__margin-fluid--ds--xlarge-1,
    .grv-row__margin-fluid--ds--xlarge-2,
    .grv-row__margin-fluid--ds--xlarge-3,
    .grv-row__margin-fluid--ds--xlarge-4,
    .grv-row__margin-fluid--ds--xlarge-5,
    .grv-row__margin-fluid--ds--tiny,
    .grv-row__margin-fluid--ds--small,
    .grv-row__margin-fluid--ds--normal,
    .grv-row__margin-fluid--ds--medium,
    .grv-row__margin-fluid--ds--large,
    .grv-row__margin-fluid--ds--xlarge,
    .grv-row__margin-fluid--ds--xxlarge {
      margin-bottom: 0px;
    }

    .grv-row__margin--ds--none,
    .grv-row__margin-fluid--ds--none > .grv-col,
    .grv-row__margin-fluid--ds--none > [class*='grv-col--'] {
      margin-bottom: 0px;
    }

    .grv-row__margin--ds--small-1,
    .grv-row__margin-fluid--ds--small-1 > .grv-col,
    .grv-row__margin-fluid--ds--small-1 > [class*='grv-col--'] {
      margin-bottom: 4px;
    }

    .grv-row__margin--ds--small-2,
    .grv-row__margin--ds--tiny,
    .grv-row__margin-fluid--ds--small-2 > .grv-col,
    .grv-row__margin-fluid--ds--tiny > .grv-col,
    .grv-row__margin-fluid--ds--small-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--tiny > [class*='grv-col--'] {
      margin-bottom: 8px;
    }

    .grv-row__margin--ds--medium-1,
    .grv-row__margin--ds--small,
    .grv-row__margin-fluid--ds--medium-1 > .grv-col,
    .grv-row__margin-fluid--ds--small > .grv-col,
    .grv-row__margin-fluid--ds--medium-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--small > [class*='grv-col--'] {
      margin-bottom: 16px;
    }

    .grv-row__margin--ds--medium-2,
    .grv-row__margin--ds--normal,
    .grv-row__margin-fluid--ds--medium-2 > .grv-col,
    .grv-row__margin-fluid--ds--normal > .grv-col,
    .grv-row__margin-fluid--ds--medium-2 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--normal > [class*='grv-col--'] {
      margin-bottom: 24px;
    }

    .grv-row__margin--ds--large-1,
    .grv-row__margin--ds--medium,
    .grv-row__margin-fluid--ds--large-1 > .grv-col,
    .grv-row__margin-fluid--ds--medium > .grv-col,
    .grv-row__margin-fluid--ds--large-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--medium > [class*='grv-col--'] {
      margin-bottom: 32px;
    }

    .grv-row__margin--ds--large-2,
    .grv-row__margin-fluid--ds--large-2 > .grv-col,
    .grv-row__margin-fluid--ds--large-2 > [class*='grv-col--'] {
      margin-bottom: 40px;
    }

    .grv-row__margin--ds--large-3,
    .grv-row__margin--ds--large,
    .grv-row__margin-fluid--ds--large-3 > .grv-col,
    .grv-row__margin-fluid--ds--large > .grv-col,
    .grv-row__margin-fluid--ds--large-3 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--large > [class*='grv-col--'] {
      margin-bottom: 48px;
    }

    .grv-row__margin--ds--large-4,
    .grv-row__margin-fluid--ds--large-4 > .grv-col,
    .grv-row__margin-fluid--ds--large-4 > [class*='grv-col--'] {
      margin-bottom: 56px;
    }

    .grv-row__margin--ds--xlarge-1,
    .grv-row__margin--ds--xlarge,
    .grv-row__margin-fluid--ds--xlarge-1 > .grv-col,
    .grv-row__margin-fluid--ds--xlarge > .grv-col,
    .grv-row__margin-fluid--ds--xlarge-1 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--xlarge > [class*='grv-col--'] {
      margin-bottom: 64px;
    }

    .grv-row__margin--ds--xlarge-2,
    .grv-row__margin-fluid--ds--xlarge-2 > .grv-col,
    .grv-row__margin-fluid--ds--xlarge-2 > [class*='grv-col--'] {
      margin-bottom: 72px;
    }

    .grv-row__margin--ds--xlarge-3,
    .grv-row__margin-fluid--ds--xlarge-3 > .grv-col,
    .grv-row__margin-fluid--ds--xlarge-3 > [class*='grv-col--'] {
      margin-bottom: 80px;
    }

    .grv-row__margin--ds--xlarge-4,
    .grv-row__margin-fluid--ds--xlarge-4 > .grv-col,
    .grv-row__margin-fluid--ds--xlarge-4 > [class*='grv-col--'] {
      margin-bottom: 88px;
    }

    .grv-row__margin--ds--xlarge-5,
    .grv-row__margin--ds--xxlarge,
    .grv-row__margin-fluid--ds--xlarge-5 > .grv-col,
    .grv-row__margin-fluid--ds--xxlarge > .grv-col,
    .grv-row__margin-fluid--ds--xlarge-5 > [class*='grv-col--'],
    .grv-row__margin-fluid--ds--xxlarge > [class*='grv-col--'] {
      margin-bottom: 96px;
    }

    .grv-grid .grv-report::after {
      content: 'ds';
    }
  }

  .grv-grid .grv-row--fill {
    margin-bottom: 0;
    padding: 0;
  }

  .grv-grid .grv-row--fill > [class*='grv-col--'] {
    padding: 0;
  }

  .grv-grid .grv-col--reverse {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: reverse;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column-reverse;
    -moz-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
  }

  .grv-grid .grv-report::after {
    background: lightblue;
    padding: 10px;
  }

  .grv-contain-width {
    height: auto;
    max-width: 100%;
  }
`;

export const gravityContainer = css`
  /* prettier-ignore */
  .grv-container {
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }

  .grv-container--radius-2 {
    border-radius: 2px;
  }

  .grv-container--radius-4 {
    border-radius: 4px;
  }
`;

export const gravityTypography = css`
  /* prettier-ignore */
  @font-face {
    font-display: swap;
    font-family: Optimist;
    font-style: normal;
    font-weight: 100;
    src: url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.eot');
    src:
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.eot?#iefix') format('embedded-opentype'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.woff2') format('woff2'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.woff') format('woff'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.ttf') format('truetype');
  }

  @font-face {
    font-display: swap;
    font-family: Optimist;
    font-style: normal;
    font-weight: 300;
    src: url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.eot');
    src:
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.eot?#iefix') format('embedded-opentype'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.woff2') format('woff2'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.woff') format('woff'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.ttf') format('truetype');
  }

  @font-face {
    font-display: swap;
    font-family: Optimist;
    font-style: normal;
    font-weight: 400;
    src: url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.eot');
    src:
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.eot?#iefix') format('embedded-opentype'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.woff2') format('woff2'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.woff') format('woff'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.ttf') format('truetype');
  }

  @font-face {
    font-display: swap;
    font-family: Optimist;
    font-style: normal;
    font-weight: 600;
    src: url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.eot');
    src:
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.eot?#iefix') format('embedded-opentype'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.woff2') format('woff2'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.woff') format('woff'),
      url('https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.ttf') format('truetype');
  }

  .grv-text--xlarge-1,
  .grv-text--xxlarge-extra-light,
  .grv-text--xxlarge,
  .grv-text--large-3,
  .grv-text--xlarge-extra-light,
  .grv-text--xlarge,
  .grv-text--large-2,
  .grv-text--large-1,
  .grv-text--large-semibold,
  .grv-text--large-light,
  .grv-text--large,
  .grv-text--medium-3,
  .grv-text--medium-large-semibold,
  .grv-text--medium-large-light,
  .grv-text--medium-large,
  .grv-text--medium-2,
  .grv-text--medium-semibold,
  .grv-text--medium-normal,
  .grv-text--medium-light,
  .grv-text--medium,
  .grv-text--medium-1,
  .grv-text--normal-semibold,
  .grv-text--normal-normal,
  .grv-text--normal,
  .grv-text--small-2,
  .grv-text--small-semibold,
  .grv-text--small-normal,
  .grv-text--small,
  .grv-text--small-1,
  .grv-text--tiny-semibold,
  .grv-text--tiny-normal,
  .grv-text--tiny,
  .grv-text__block--tiny,
  .grv-text__block--small,
  .grv-text__block--normal,
  .grv-text__block--medium,
  .grv-text__heading--tiny,
  .grv-text__heading--small,
  .grv-text__heading--normal,
  .grv-text__heading--medium,
  .grv-text__heading--medium-large,
  .grv-text__heading--large,
  .grv-text__heading--xlarge,
  .grv-text__heading--xxlarge,
  .grv-font,
  [class*='grv-text__body'],
  [class*='grv-text__heading'],
  .grv-text__block,
  [class*='grv-text__block'] {
    font-family: Optimist, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  [class*='grv-text__body'] {
    font-size: 1.5;
    font-weight: 400;
  }

  .grv-text__block,
  [class*='grv-text__block'] {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin: 0;
    margin-bottom: 24px;
  }

  [class*='grv-text__heading'] {
    margin: 0;
  }

  .grv-font {
    font-size: 16px;
    line-height: 1.5;
  }

  .grv-text__heading--xxlarge {
    font-size: 64px;
    font-weight: 100;
    line-height: 1.2;
    margin-bottom: 48px;
  }

  .grv-text__heading--xlarge {
    font-size: 48px;
    font-weight: 100;
    line-height: 1.3;
    margin-bottom: 32px;
  }

  .grv-text__heading--large {
    font-size: 32px;
    font-weight: 300;
    line-height: 1.3;
    margin-bottom: 24px;
  }

  .grv-text__heading--medium-large {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .grv-text__heading--medium {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .grv-text__heading--normal {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .grv-text__heading--small {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .grv-text__heading--tiny {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .grv-text__body--medium {
    font-size: 20px;
  }

  .grv-text__body--normal {
    font-size: 16px;
  }

  .grv-text__body--small {
    font-size: 14px;
  }

  .grv-text__body--tiny {
    font-size: 12px;
  }

  .grv-text__link {
    color: #0276b1;
    text-decoration: underline;
  }

  .grv-text__link:visited {
    color: #639;
  }

  .grv-text__link:hover {
    color: #026597;
  }

  .grv-text__link:active {
    color: #014e74;
  }

  .grv-text__link--light {
    color: #fff;
    text-decoration: underline;
  }

  .grv-text__link--light:visited {
    color: #fff;
  }

  .grv-text__link--light:hover {
    color: #d4d4d4;
  }

  .grv-text__link--light:active {
    color: #d4d4d4;
  }

  .grv-text__link--no-style {
    color: inherit;
    text-decoration: none;
  }

  .grv-text__link--no-style:visited {
    color: inherit;
  }

  .grv-text__link--no-style:hover {
    color: inherit;
  }

  .grv-text__link--no-style:active {
    color: inherit;
  }

  .grv-text__block--medium {
    font-size: 20px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text__block--normal {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text__block--small {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text__block--tiny {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--small-1,
  .grv-text--tiny-semibold,
  .grv-text--tiny-normal,
  .grv-text--tiny {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--small-2,
  .grv-text--small-semibold,
  .grv-text--small-normal,
  .grv-text--small {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--medium-1,
  .grv-text--normal-semibold,
  .grv-text--normal-normal,
  .grv-text--normal {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--medium-2,
  .grv-text--medium-semibold,
  .grv-text--medium-normal,
  .grv-text--medium-light,
  .grv-text--medium {
    font-size: 20px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--medium-3,
  .grv-text--medium-large-semibold,
  .grv-text--medium-large-light,
  .grv-text--medium-large {
    font-size: 24px;
    font-weight: 400;
    line-height: 1.5;
  }

  .grv-text--large-1,
  .grv-text--large-semibold,
  .grv-text--large-light,
  .grv-text--large {
    font-size: 32px;
    font-weight: 400;
    line-height: 1.3;
  }

  .grv-text--large-2 {
    font-size: 40px;
    font-weight: 400;
    line-height: 1.3;
  }

  .grv-text--large-3,
  .grv-text--xlarge-extra-light,
  .grv-text--xlarge {
    font-size: 48px;
    font-weight: 400;
    line-height: 1.3;
  }

  .grv-text--xlarge-1,
  .grv-text--xxlarge-extra-light,
  .grv-text--xxlarge {
    font-size: 64px;
    font-weight: 400;
    line-height: 1.2;
  }

  .grv-text--medium-large,
  .grv-text--large {
    font-weight: 300;
  }

  .grv-text--xlarge,
  .grv-text--xxlarge {
    font-weight: 100;
  }

  .grv-weight--extra-light,
  .grv-text--extra-light,
  .grv-text--xxlarge-extra-light,
  .grv-text--xlarge-extra-light {
    font-weight: 100;
  }

  .grv-weight--light,
  .grv-text--light,
  .grv-text--large-light,
  .grv-text--medium-large-light,
  .grv-text--medium-light {
    font-weight: 300;
  }

  .grv-weight--normal,
  .grv-text--normal,
  .grv-text--medium-normal,
  .grv-text--normal-normal,
  .grv-text--small-normal,
  .grv-text--tiny-normal {
    font-weight: 400;
  }

  .grv-weight--semibold,
  .grv-text--semibold,
  .grv-text--large-semibold,
  .grv-text--medium-large-semibold,
  .grv-text--medium-semibold,
  .grv-text--normal-semibold,
  .grv-text--small-semibold,
  .grv-text--tiny-semibold {
    font-weight: 600;
  }
`;
/* eslint-enable */
/* stylelint-enable */